import React, { useEffect, useState } from 'react';
import { Col, Layout, Row, Button, Image, Modal } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import TestSidebar from '../component/TestSidebar';
import { Icons, Images } from '../../../controller/Images';
import Question from '../component/Question';
import { useTimerStore } from '../../../store/timerReducer';
// import { usecandidateSidebarStore } from '../../../store/candidateSidevarReducer';
import { usecandidateTestStore } from '../../../store/candidateReducer';
import { clearCandidateToken, getCandidateDetail } from '../../../controller/localStroageHandler';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { exitFullScreen } from '../../../controller/Fullscreen';
import { submitTest } from '../../../controller/api/candidateServices';
import { Footer } from 'antd/es/layout/layout';
import { useVideoStreamStore } from '../../../store/CamareStreamResucer';

const { Content, Header } = Layout;

const TestPage = () => {
  const logo = localStorage.getItem('candidate_logo')
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [tabChange, setTabChage] = useState(false)
  // const [minutes, setMinutes] = useState(10);
  // const [seconds, setSeconds] = useState(0);
  const { updateTimer, min, sec } = useTimerStore((state) => state);
  const navigate = useNavigate();
  const { updateStream, clearStream } = useVideoStreamStore()
  const [buttonLoading, setButtonLoading] = useState(false);
  // const [completeSection, setCompleteSection] = useState(0);
  // const { menuItem, menuItemValue } = usecandidateSidebarStore(
  //   (state) => state
  // );
  useEffect(() => {
    hanldeCameraAndmicAccess()
  }, [])
  const handleSubmit = (nextRoute) => {
    setButtonLoading(true);
    localStorage.removeItem('tabchangecount');
    const now = new Date();
    const currentTimeInISOString = now.toISOString();
    let candidateDetails = getCandidateDetail()
    let payload = {
      userResponse: testquestions,
      startTime: startTime,
      endTime: currentTimeInISOString,
      CandidateId: candidateDetails?._id,
    };
    submitTest(payload).then((res) => {
      console.log('res ====>', res);
      exitFullScreen(document.documentElement)
      clearStream()
      clearCandidateToken();
      navigate(nextRoute)
      setButtonLoading(false);
    }).catch((err) => {
      console.log('err ====>', err)
      setButtonLoading(false);
    });
    return false;
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape' || event.key === 'escape' || event.keyCode === 27) {
        // Esc key
        event.preventDefault();
      }
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key.toLowerCase() === 'r' ||
          event.key.toLowerCase() === 'c' ||
          event.key.toLowerCase() === 's' ||
          event.key.toLowerCase() === 'x' ||
          event.key.toLowerCase() === 'n' ||
          event.key.toLowerCase() === 'f' ||
          event.key.toLowerCase() === 'tab')
      ) {
        event.preventDefault();
        console.log('prevent the tab and copy shortcut');
      }
      if (event?.shiftKey || event?.altKey) {
        event.preventDefault();
        console.log('prevent shift and alt key');
      }
      if (
        event.key &&
        event.key.startsWith('F') &&
        !isNaN(event.key.slice(1))
      ) {
        event.preventDefault();
        console.log('Function key press prevented');
      }

      if (event.key === 'PrintScreen') {
        event.preventDefault();
        document.body.classList.add('hide-content');
        setTimeout(() => {
          document.body.classList.remove('hide-content');
        }, 100);
        console.log('Screenshot prevented');
      }
    };
    let timeoutId;

    const handleVisibilityChange = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (document.visibilityState === 'visible') {
          console.log('visible');
        } else {
          let count = localStorage.getItem('tabchangecount')
          if (count == null) {
            localStorage.setItem('tabchangecount', 1)
            setTabChage(true)
          } else {
            let updateCount = parseInt(count || 0) + 1
            if (updateCount === 2) {
              // eslint-disable-next-line
              handleSubmit(routes?.test?.taboverlimit);
            }
          }
        }
      }, 100);
    };

    const handleContextMenu = (event) => {
      event.preventDefault();
      console.log('Right-click context menu prevented');
    };
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', function (event) {
      const message = "Are you sure you want to leave? If you leave the tab, it will be automatically submitted.";
      event.returnValue = message; // Standard for most browsers
      return message; // For some older browsers
    });

    window.addEventListener('unload', function () {
      handleSubmit(routes?.test?.taboverlimit);
    });
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(timeoutId);

    };
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      if (min === 0 && sec === 0) {
        // eslint-disable-next-line
        handleSubmit(routes?.test?.timeover);
        clearInterval(timer);
      } else {
        if (sec === 0) {
          // eslint-disable-next-line
          updateTimer(min - 1, 59);
        } else {
          // eslint-disable-next-line
          updateTimer(min, sec - 1);
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [min, sec]);
  // const menuItem = [
  //   {
  //     name: 'theory',
  //     complete: 0,
  //   },
  //   {
  //     name: 'analytical',
  //     complete: 0,
  //   },
  //   {
  //     name: 'coding',
  //     complete: 0,
  //   },
  // ];
  // useEffect(() => {
  //   let count = menuItem.reduce((acc, item) => {
  //     if (item.complete === 100) {
  //       return acc + 1;
  //     } else {
  //       return acc;
  //     }
  //   }, 0);
  //   setCompleteSection(count);
  // }, [menuItem]);

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };
  const { startTime, testquestions } = usecandidateTestStore((state) => state);
  const hanldeCameraAndmicAccess = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      if (stream) {
        updateStream(stream);
      }
    } catch (error) {
      console.error("Error accessing camera and microphone:", error);
    }
  };
  return (
    <>
      <Layout className='w-100 h-100 bg-white cadidate-test-page-container'>
        <TestSidebar
          toggleDrawer={toggleDrawer}
          drawerVisible={drawerVisible}
        />
        <Layout style={{ height: '100vh' }}>
          <Content className='bg-white w-100 h-100 position-relative'>
            <Header
              className='test-container-header gap-2 border-bottom'
            >
              <div className=' d-block gap-2 d-lg-none'>
                <Button
                  type='text'
                  icon={<MenuOutlined />}
                  onClick={toggleDrawer}
                  className='d-lg-none'
                />
                <Image
                  src={logo || Images.logo}
                  alt=''
                  className='logo'
                  height={40}
                  preview={false}
                />
              </div>
              <div
                className='d-flex  justify-content-center align-items-center gap-2 timer-div-bg-color timer-div-container rounded-5 fw-semibold'
                style={{ height: '41px' }}
              >
                <Image className='green-icon' src={Icons.timerIcon} alt='' preview={false} />
                <span className={`${min === 0 && 'text-danger'}`}>
                  {min > 0 && `${min} Min`} {sec} Sec
                </span>
              </div>
            </Header>
            <div className='w-100  candidate-test-container'>
              {/* <Row justify={'end'} className='w-100 candidate-time'> */}
              {/* <Col className='w-100' lg={19} sm={24} md={24}>
                  <Row gutter={5}>
                    {menuItem?.map((val, index) => {
                      return (
                        <>
                          <Col
                            key={index}
                            span={Math.floor(24 / menuItem?.length)}
                            className='d-flex flex-column justify-content-end'
                          >
                            {menuItemValue == index ? (
                              <>
                                <span className='d-flex justify-content-center'>
                                  {Math.round(val?.complete)}% Completed
                                </span>
                                <Progress
                                  percent={val?.complete}
                                  showInfo={false}
                                />
                              </>
                            ) : (
                              <Progress
                                percent={val?.complete}
                                showInfo={false}
                              />
                            )}
                          </Col>
                          {menuItem?.length - 1 == index && (
                            <span className='w-100 d-flex justify-content-end'>
                              {completeSection}/{menuItem?.length}
                            </span>
                          )}
                        </>
                      );
                    })}
                  </Row>
                </Col> */}
              {/* <Col
                  span={5}
                  className='d-flex justify-content-end align-items-center d-sm-none d-lg-grid timer-grid-container'
                >
                  <div className='d-flex justify-content-center align-items-center gap-2 timer-div-bg-color p-md-2 p-xl-3 rounded-5 fw-semibold'>
                    <Image src={Icons.timerIcon} alt='' preview={false} />
                    <span className={`${min === 0 && 'text-danger'}`}>
                      {min > 0 && `${min} Min`} {sec} Sec
                    </span>
                  </div>
                </Col> */}
              {/* </Row> */}
              <Question buttonLoading={buttonLoading} submit={handleSubmit} />
              {/* <Footer>dkndk</Footer> */}
            </div>
            <Modal
              width={350}
              className='submit-popup'
              title=''
              open={tabChange}
              footer={null}
              closeIcon={null}
            >
              <div className='w-100  text-center d-flex flex-column gap-3'>
                <span className=' fs-5 fw-bold '>
                  This is your final warning.
                </span>
                <p className='paragraph'>
                  If you change the tab again, the test will be automatically submitted
                </p>
                <Row justify={'end'} gutter={[12, 12]}>
                  <Col span={8}>
                    <Button
                      type='primary'
                      className=' w-100 button-color fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn submit-btn'
                      onClick={() => { setTabChage(false) }}
                    >
                      ok
                    </Button>
                  </Col>
                </Row>
              </div>
            </Modal>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default TestPage;
